import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Icon } from '@a-type/ui';
import { useState } from 'react';
import { updateApp, useIsUpdateAvailable } from './updateState.js';
const TEST = false;
export function UpdatePrompt({ className }) {
    const updateAvailable = useIsUpdateAvailable();
    const [loading, setLoading] = useState(false);
    if (!updateAvailable && !TEST) {
        return null;
    }
    return (_jsxs(Box, { full: "width", surface: "primary", gap: true, col: true, items: "start", rounded: true, p: true, className: className, children: [_jsxs("div", { children: [_jsx(Icon, { name: "star" }), "\u00A0App update available!"] }), _jsx(Button, { loading: loading, emphasis: "primary", onClick: async () => {
                    try {
                        setLoading(true);
                        await updateApp(true);
                    }
                    finally {
                        setLoading(false);
                    }
                }, children: "Get the latest" })] }));
}
//# sourceMappingURL=UpdatePrompt.js.map